const getStaticAssetDomain = (staticAssetDomains, group, fallback) => staticAssetDomains?.[group] || fallback;

export default getStaticAssetDomain;
